// extracted by mini-css-extract-plugin
module.exports = {"normal":"Normal_normal__Ri7SE","title":"Normal_title__xgBrt","text":"Normal_text__1wuSn"};